// components/leads/LeadSearchFilter.js
// Barra di ricerca e filtro stato

import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Search, Filter } from 'lucide-react';

const workflowSteps = [
  { status: 'nuovo', label: 'Nuovo' },
  { status: 'contattato', label: 'Contattato' },
  { status: 'assegnato', label: 'Assegnato' },
  { status: 'appuntamento_fissato', label: 'Appuntamento' },
  { status: 'sopralluogo_effettuato', label: 'Sopralluogo' },
  { status: 'in_preventivazione', label: 'Preventivazione' },
  { status: 'preventivo_presentato', label: 'Presentato' },
  { status: 'in_trattativa', label: 'Trattativa' },
  { status: 'in_contratto', label: 'Contratto' },
  { status: 'convertito', label: 'Convertito' },
];

const LeadSearchFilter = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter
}) => {
  return (
    <Card className="card-abitalo">
      <CardContent className="p-4">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#737373]" />
            <Input
              placeholder="Cerca per nome, indirizzo, telefono..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="input-abitalo pl-10"
              data-testid="leads-search-input"
            />
          </div>
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger className="w-full sm:w-56" data-testid="leads-status-filter">
              <Filter className="w-4 h-4 mr-2 text-[#737373]" />
              <SelectValue placeholder="Filtra per stato" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutti gli stati</SelectItem>
              {workflowSteps.map(step => (
                <SelectItem key={step.status} value={step.status}>
                  {step.label}
                </SelectItem>
              ))}
              <SelectItem value="non_risponde">Non Risponde</SelectItem>
              <SelectItem value="perso">Perso</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default LeadSearchFilter;
